import ListType from "./CreateOrEdit/ListType";
import Deal from "./CreateOrEdit/ListTypeModules/Deal";
import Domain from "./CreateOrEdit/ListTypeModules/Domain";
import ZipFile from "./CreateOrEdit/ListTypeModules/ZipFile";
import Overview from "./CreateOrEdit/Overview";

export const listTypeList = [
  // {
  //   label: "App Bundle List",
  //   value: "app_bundle",
  // },
  // {
  //   label: "App ID List",
  //   value: "app_id",
  // },
  {
    label: "Deal List",
    value: "deal_id",
    componentKey: "deal",
  },
  {
    label: "Domain List",
    value: "domain",
    componentKey: "domain",
  },
  // {
  //   label: "IP Address  List",
  //   value: "4",
  // },
  // {
  //   label: "Lat/Long List",
  //   value: "lat_long",
  // },
  // {
  //   label: "Placement ID List",
  //   value: "placement_id",
  // },
  // {
  //   label: "Publisher ID List",
  //   value: "publisher_id",
  // },
  // {
  //   label: "Site ID List",
  //   value: "site_id",
  // },
  {
    label: "Zip Code List",
    value: "zip_code",
    componentKey: "zip",
  },
];

export const listTabs = (isEdit = false, id: number | null = null) => [
  {
    label: "Overview",
    id: 0,
    disabled: isEdit ? false : id ? true : false,
  },
  {
    label: "List Item",
    id: 1,
    disabled: isEdit ? false : id ? false : true,
  },
];

export const tabToComponent: { [k in number]: any } = listTabs()?.reduce(
  (acc, tab) => {
    if (tab.id === 0) {
      return (acc = { ...acc, [tab.id]: Overview });
    }
    if (tab.id === 1) return (acc = { ...acc, [tab.id]: ListType });

    return acc;
  },
  {}
);

export const listItemModuleByType = {
  zip: ZipFile,
  deal: Deal,
  domain: Domain,
};

export const listItemsTableHeaders = [
  { id: "id", label: "ID" },
  { id: "listItem", label: "List Item" },
  { id: "value", label: "Value" },
  { id: "name", label: "List Item Name" },
];

export const CustomListTableHeaders = [
  { id: "id", label: "ID" },
  { id: "name", label: "List Name" },
  { id: "type", label: "List Type" },
  { id: "archive", label: "Archive" },
];
